export default __webpack_public_path__ + "static/media/signup-icon-professional.2f2abda7.svg";